import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {NewUserComponent} from '../new-user/new-user.component';
import {UserModel} from './../../../models/user/users.model';
import {UsersService} from './../users.service';
import {FormBuilder, Validators} from '@angular/forms';
import {AuthTokenService} from '../../../shared/services/auth-token.service';
import {PreviousUrlService} from '../../../shared/services/previous-url.service';
import {CustomValidators} from 'ng2-validation';
import {CommunicationService} from '../../../shared/services/communication.service';
import {SidebarService} from '../../../shared/services/sidebar.service';
import { Role } from '../../../enums/role.enum';
import { SELECT_TEXT } from '../../../shared/constants/input.constants';
import { ClientEnum } from '../../../models/survey/survey.model';

@Component({
  selector: 'app-edit-user',
  templateUrl: './../new-user/new-user.component.html',
  styleUrls: ['./../new-user/new-user.component.less'],
})

export class EditUserComponent extends NewUserComponent implements OnInit {

  userId: number;
  user: UserModel;
  isAdmin: boolean;
  isCustomerAdmin: boolean;
  currentClient: string;
  constructor(protected sidebarService1: SidebarService,
              protected route: ActivatedRoute,
              protected communicationService: CommunicationService,
              protected usersService1: UsersService,
              protected previousUrl: PreviousUrlService,
              protected fb1: FormBuilder,
              protected router1: Router,) {
    super(usersService1, fb1, sidebarService1, router1, route);
    this.route.params.subscribe();
    this.userForm = this.fb.group({
      'firstName': [null, Validators.compose([Validators.required, Validators.maxLength(50)])],
      'lastName': [null, Validators.compose([Validators.required, Validators.maxLength(50)])],
      'email': [null, Validators.compose([Validators.required, Validators.maxLength(50), CustomValidators.email])],
      'position': [null, Validators.compose([Validators.required, Validators.maxLength(20)])],
      'password': [null, Validators.compose([Validators.maxLength(50), Validators.minLength(4), Validators.pattern(this.patternPassword)])],
      'confirmPassword': [null]
    });
  }

  ngOnInit() {
    this.previousUrl.setSurveyTitle('Edit User');
    this.goToPrevious();
    this.userId = parseInt(this.route.snapshot.paramMap.get('id'), 10);
    this.positions = [];
    this.user = new UserModel();
    const currentUser = AuthTokenService.getUser();
    this.isCurrentUser = currentUser && currentUser.id === this.userId;
    this.usersService1.getUser(this.userId).subscribe(
      (response) => {
        this.user = response;
        if (+this.user.role === 0) {
          this.dropdownLabel = 'Any';
        } else {
          const role = this.user.listEnumRoles.find(e => {
            return e.value == this.user.role;
          });
          if (role !== undefined) {
            this.dropdownLabel = role.name;
          }
        }
        const client = this.clients.find(item => {
            return item.id == this.user.clientId;
        });
        if (client !== undefined) {
            this.currentClient = client.name;
            if (client.name === ClientEnum.INTERNAL) {
                for (let i = 0; i < this.user.listEnumRoles.length; i++) {
                    if (this.user.listEnumRoles[i].value.toLocaleLowerCase() === Role.ADMIN.toLocaleLowerCase() || this.user.listEnumRoles[i].value.toLocaleLowerCase() === Role.USER.toLocaleLowerCase()) {
                        this.positions.push(this.user.listEnumRoles[i].name);
                    }
                }
            } else {
                for (let i = 0; i < this.user.listEnumRoles.length; i++) {
                    if (this.user.listEnumRoles[i].value.toLocaleLowerCase() === Role.CUSTOMER_ADMIN.toLocaleLowerCase() || this.user.listEnumRoles[i].value.toLocaleLowerCase() === Role.CUSTOMER_USER.toLocaleLowerCase()) {
                        this.positions.push(this.user.listEnumRoles[i].name);
                    }
                }
            }
        }
      },
      _ => {
      }
    );
    this.isAdmin = AuthTokenService.isAdmin();
    this.isCustomerAdmin = AuthTokenService.isCustomerAdmin();
  }

  checkIfPasswordsMatch() {
    if (this.password) {
      if (this.user.password !== this.user.confirmPassword) {
        this.changePassError = true;
      } else {
        this.changePassError = false;
      }
    }
  }

  saveUser() {
    if (this.password) {
      if (this.user.password != null && this.user.password !== this.user.confirmPassword) {
        this.changePassError = true;
        return false;
      }
    } else {
      this.changePassError = false;
      this.user.password = null;
    }

    if (sessionStorage.getItem('User') !== null) {
      const userInfo = JSON.parse(sessionStorage.getItem('User'));
      if (userInfo.user.id === this.user.id) {
        this.communicationService.userFirstName.next(this.user.firstName);
        this.communicationService.userLastName.next(this.user.lastName);
      }
    }
    this.usersService1.save(this.user).subscribe(
      (response) => {
        // AuthTokenService.setUser(response.user);
        // this.router1.navigate(['users']);
        if (this.goToPrevious()) {
          this.previousUrl.router.navigate(['users']);
        } else {
          this.previousUrl.router.navigate(['dashboard']);
        }
      },
      (error) => {
        // console.log(error);
      }
    );
  }

  goToPrevious() {
    const previous = this.previousUrl.getPreviousUrl();

    if (previous.indexOf('users') > -1) {
      return true;
    } else {
      return false;
    }
  }

  onUserActiveChange(e) {
    this.user.active = e.srcElement.checked;
  }

  setClient(e): void {
    const client = this.clients.find(item => {
        return item.id == e.id;
    });
    if (client !== undefined) {
        this.user.clientId = client.id;
    }

    this.positions = [];
    this.dropdownLabel = SELECT_TEXT;
    this.user.role = null;
    if (client.name === ClientEnum.INTERNAL) {
        for (let i = 0; i < this.user.listEnumRoles.length; i++) {
            if (this.user.listEnumRoles[i].value.toLocaleLowerCase() === Role.ADMIN.toLocaleLowerCase() || this.user.listEnumRoles[i].value.toLocaleLowerCase() === Role.USER.toLocaleLowerCase()) {
                this.positions.push(this.user.listEnumRoles[i].name);
            }
        }
    } else {
        for (let i = 0; i < this.user.listEnumRoles.length; i++) {
            if (this.user.listEnumRoles[i].value.toLocaleLowerCase() === Role.CUSTOMER_ADMIN.toLocaleLowerCase() || this.user.listEnumRoles[i].value.toLocaleLowerCase() === Role.CUSTOMER_USER.toLocaleLowerCase()) {
                this.positions.push(this.user.listEnumRoles[i].name);
            }
        }
    }
  }

  isUserRole(user: UserModel) {
    if (user && user.role) {
        return user.role.toLocaleLowerCase() === Role.USER.toLocaleLowerCase() || user.role.toLocaleLowerCase() === Role.CUSTOMER_USER.toLocaleLowerCase();
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/routes/users/edit-user/edit-user.component.ts